import _ from "lodash";
import generateApiClient from "../helpers/generateApiClient";

import {
  POLLS_FETCH_FAILURE,
  POLLS_FETCH_SUCCESS,
  POLLS_SAVE_SUCCESS,
  POLLS_SAVE_FAILURE,
  ARCHIVE_SAVE_SUCCESS,
  ARCHIVE_SAVE_FAILURE,
  RESPONSE_SUBMITTED_SUCCESS,
  RESPONSE_SUBMITTED_FAILURE,
  FETCH_RESPONSE_REPORT_SUCCESS,
  FETCH_RESPONSE_REPORT_FAILURE,
  CLEAR_RESPONSE_REPORT,
} from "../constants/pollConstant";
import getErrorMessage from "../helpers/getErrorMessage";
import { push } from "react-router-redux";

const fetchSuccess = (data) => ({ type: POLLS_FETCH_SUCCESS, data });
const fetchFailure = (error) => ({ type: POLLS_FETCH_FAILURE, error });

const saveSuccess = (data) => ({ type: POLLS_SAVE_SUCCESS, data });
const saveFailure = (error) => ({ type: POLLS_SAVE_FAILURE, error });

const archiveSuccess = (data) => ({ type: ARCHIVE_SAVE_SUCCESS, data });
const archiveFailure = (error) => ({ type: ARCHIVE_SAVE_FAILURE, error });

const responseSubmittedSuccess = (data) => ({
  type: RESPONSE_SUBMITTED_SUCCESS,
  data,
});
const responseSubmittedFailure = (error) => ({
  type: RESPONSE_SUBMITTED_FAILURE,
  error,
});

const responseReportSuccess = (data) => ({
  type: FETCH_RESPONSE_REPORT_SUCCESS,
  data,
});
const responseReportFailure = (error) => ({
  type: FETCH_RESPONSE_REPORT_FAILURE,
  error,
});

export function fetch() {
  return (dispatch, getState) => {
    const client = generateApiClient(getState);
    return client
      .get("/api/v1/polls")
      .then((response) => {
        dispatch(fetchSuccess(response?.data));
      })
      .catch((error) => {
        console.log(error);

        dispatch(fetchFailure(getErrorMessage(error)));
      });
  };
}

export function save(pollsData, navigate, setLoading) {
  return (dispatch, getState) => {
    const client = generateApiClient(getState);
    const params = {
      data: pollsData.data,
    };

    if (pollsData.id === "new") {
      setLoading(true);
      return client
        .post("/api/v1/polls", params)
        .then((response) => {
          const redirect = `/poll/${response.data.id}`;
          if (window && window.usermaven && response && response.data) {
            const params = { userId: response.data?.ownerId, slug: response.data?.slug, poll_type: response.data?.poll_type }
            window.usermaven("track", "polls_created", params);
          }
          navigate(redirect);
          dispatch(saveSuccess(response.data));
          setLoading(false);
          
        })
        .catch((error) => {
          setLoading(false);
          console.log(error, "1");
          dispatch(saveFailure(getErrorMessage(error)));
        });
    } else {
      setLoading(true);
      return client
        .put("/api/v1/polls/" + pollsData.id, params)
        .then((response) => {
          dispatch(saveSuccess(response.data));
          const redirect = `/poll/${response.data.id}`;
          navigate(redirect);
          setLoading(false);
        })
        .catch((error) => {
          console.log(error, "2");
          dispatch(saveFailure(getErrorMessage(error)));
          setLoading(false);
        });
    }
  };
}

export function pollArchive(pollsData) {
  return (dispatch, getState) => {
    const client = generateApiClient(getState);
    return client
      .patch(`/api/v1/polls/${pollsData.id}/archive`, {
        archived: pollsData.archived,
      })
      .then((response) => {
        dispatch(archiveSuccess(pollsData));
        const redirect = `/poll/${response.data.id}`;
        dispatch(push(redirect));
      })
      .catch((error) => {
        dispatch(archiveFailure(getErrorMessage(error)));
      });
  };
}

export function submitResponse(params, setSubmitting) {
  return (dispatch, getState) => {
    const client = generateApiClient(getState);
    setSubmitting(true);
    return client
      .post("/api/v1/polls_response?" + params)
      .then((response) => {
        dispatch(responseSubmittedSuccess(response?.data));
        setSubmitting(false);
      })
      .catch((error) => {
        setSubmitting(false);
        dispatch(responseSubmittedFailure(getErrorMessage(error)));
      });
  };
}

export function fetchResponse(slug) {
  return (dispatch, getState) => {
    const client = generateApiClient(getState);
    return client
      .get("/api/v1/polls_response/aggregate?poll_slug=" + slug)
      .then((response) => {
        dispatch(responseReportSuccess(response?.data));
        // dispatch({ type: CLEAR_RESPONSE_REPORT })
      })
      .catch((error) => {
        dispatch(responseReportFailure(getErrorMessage(error)));
        // dispatch({ type: CLEAR_RESPONSE_REPORT })
      });
  };
}
